import { lensAddOnStepBase } from "../../../../../shared/state/configurator/steps/shared/lens-add-on.js";
import { lensAddOnVariantStep } from "../../../../../shared/state/configurator/steps/shared/lens-add-on-variant.js";
import { lensPackageStepBase } from "../../../../../shared/state/configurator/steps/shared/lens-package.js";
import { lensTypeStepBase } from "../../../../../shared/state/configurator/steps/shared/lens-type.js";
import { lensTypeVariantStep } from "../../../../../shared/state/configurator/steps/shared/lens-type-variant.js";
import { prescriptionEntrySelectionStepBase } from "../../../../../shared/state/configurator/steps/shared/prescription-entry-selection.js";
import { prescriptionFormStepBase } from "../../../../../shared/state/configurator/steps/shared/prescription-form.js";
import { prescriptionUploadStepBase } from "../../../../../shared/state/configurator/steps/shared/prescription-upload.js";
import { prescriptionValidationStepBase } from "../../../../../shared/state/configurator/steps/shared/prescription-validation.js";
import { reviewStepBase } from "../../../../../shared/state/configurator/steps/shared/review.js";
const labelKeys = {
  lensType: {
    stepIndicatorTitle: "products.rxsun.configurator.step.lensType",
    title: "products.rxsun.lensType.title",
    description: "products.rxsun.lensType.description"
  },
  lensTypeVariant: {
    title: "products.rxsun.lensTypeVariant.title",
    description: "products.rxsun.lensTypeVariant.description"
  },
  prescriptionEntrySelection: {
    stepIndicatorTitle: "products.rxsun.configurator.step.prescription",
    title: "products.rxsun.prescriptionEntry.title",
    description: "products.rxsun.prescriptionEntry.description"
  },
  prescriptionUpload: {
    title: "products.rxsun.prescriptionUpload.title",
    description: "products.rxsun.prescriptionUpload.description"
  },
  prescriptionForm: {
    title: "products.rxsun.prescriptionForm.title",
    description: "products.rxsun.prescriptionForm.description"
  },
  prescriptionValidation: {
    stepIndicatorTitle: "products.rxsun.configurator.step.prescriptionValidation",
    title: "products.rxsun.validationStep.title",
    description: "products.rxsun.validationStep.description"
  },
  lensPackage: {
    stepIndicatorTitle: "products.rxsun.configurator.step.lensPackage",
    title: "products.rxsun.lensPackage.title",
    description: "products.rxsun.lensPackage.description"
  },
  lensAddOn: {
    stepIndicatorTitle: "products.rxsun.configurator.step.lensAddOn",
    title: "products.rxsun.lensAddOn.title",
    description: "products.rxsun.lensAddOn.description"
  },
  lensAddOnVariant: {
    title: "products.rxsun.lensAddOnVariant.title",
    description: "products.rxsun.lensAddOnVariant.description"
  },
  review: {
    stepIndicatorTitle: "products.rxsun.configurator.step.review",
    title: "products.rxsun.review.title",
    description: "products.rxsun.review.description"
  }
};
const stepsMap = {
  lensType: {
    ...lensTypeStepBase,
    labelKeys: {
      ...labelKeys.lensType,
      alternativeCta: "products.rxsun.lensType.selectVariant"
    }
  },
  lensTypeVariant: {
    ...lensTypeVariantStep,
    labelKeys: labelKeys.lensTypeVariant
  },
  prescription: {
    ...prescriptionEntrySelectionStepBase,
    labelKeys: labelKeys.prescriptionEntrySelection
  },
  prescriptionUpload: {
    ...prescriptionUploadStepBase,
    labelKeys: labelKeys.prescriptionUpload
  },
  prescriptionForm: {
    ...prescriptionFormStepBase,
    labelKeys: labelKeys.prescriptionForm
  },
  prescriptionValidation: {
    ...prescriptionValidationStepBase,
    labelKeys: labelKeys.prescriptionValidation
  },
  lensPackage: {
    ...lensPackageStepBase,
    labelKeys: labelKeys.lensPackage
  },
  lensAddOn: {
    ...lensAddOnStepBase,
    labelKeys: labelKeys.lensAddOn
  },
  lensAddOnVariant: {
    ...lensAddOnVariantStep,
    labelKeys: {
      ...labelKeys.lensAddOnVariant,
      alternativeCta: "products.rxsun.lensAddOn.selectVariant"
    }
  },
  review: {
    ...reviewStepBase,
    labelKeys: labelKeys.review
  }
};
export {
  stepsMap
};
//# sourceMappingURL=index.js.map
